"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const defineAppConfig_1 = require("../defineAppConfig");
exports.default = (0, defineAppConfig_1.defineAppConfig)({
    appName: 'Liella! Collection',
    organizationId: 'N3h112IsKwvvPlyZ88Pc',
    applicationKey: 'liella',
    applicationType: 'standalone',
    artistId: 'jqC953f59ThhTrHQN1D7yVyATII2',
    ionicAppId: 'b6e951a0',
    platform: ['web', 'native'],
    ios: {
        bundleId: 'com.utoniq.liellacollection',
        appId: '6473574981',
    },
    android: {
        bundleId: 'com.utoniq.liellacollection',
    },
    deeplinkUrl: 'https://liellacollection.utoniq.com',
    helpUrl: 'https://help.utoniq.com/ja/collections/7203956',
    storagePath: 'liellacollection',
    dynamicLinkPrefix: 'liellacollection',
    deeplinkProd: 'liellacollection.utoniq.com',
    custom: {
        modules: {
            trade: true,
            thread: true,
            prepaidPoint: { chargeable: true },
            gacha: true,
            item: true,
            store: true,
            mission: true,
            konbiniPayment: true,
        },
        tutorials: [
            'images/tutorial/Tutorial01.jpg',
            'images/tutorial/Tutorial02.jpg',
            'images/tutorial/Tutorial03.jpg',
            'images/tutorial/Tutorial04.jpg',
        ],
        globalTabs: [],
        artistTabs: ['home', 'collections', 'gachas', 'trade', 'myProfile'],
    },
});
